module.exports = __webpack_public_path__ + "assets/img/footlogo.9072e371.png";